// @ts-nocheck
import { makeStyles, Box, Grid } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flex: '1',
    padding: theme.spacing(3),
  },
  fill: {
    flex: '1',
  },
}));

function FullScreenLoading() {
  const classes = useStyles();

  return (
    <Box id="FullScreenLoading" className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={2}>
          <Skeleton variant="rect" height="100%" />
        </Grid>
        <Grid item xs={10} container direction="column">
          <Skeleton variant="rect" height={76} />
          <Box height={24} />
          <Skeleton variant="rect" className={classes.fill} />
        </Grid>
      </Grid>
    </Box>
  );
}

export default FullScreenLoading;
